export default "__VITE_ASSET__sEmgTVPM__"